export const unseenMessageScreenReaderOnlyText = "vzc";
export const unseenMessagesScreenReaderOnlyText = "wzc";
export default {unseenMessageScreenReaderOnlyText,unseenMessagesScreenReaderOnlyText};